export const combineUrlParams = (params: any = {}) => {
    const keys = Object.keys(params);
    const paramUrl = keys
        .filter((key) => ![undefined, null, ""].includes(params[key]))
        .map((key) => `${key}=${params[key]}`)
        .join("&");
    return `?${paramUrl}`;
};